import { Stack } from '@mui/joy';
import { Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import partBomNoItems from 'assets/partBomNoItems.svg';
import { Image } from 'core/elements';
import { Level } from 'theme/enums';

interface IProps {
  inline?: boolean;
}

export const NoRowsOverlay = ({ inline = false }: IProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        gap: 2,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 4,
      }}
    >
      <Image
        src={partBomNoItems}
        alt={t('labelPartBomNoParts')}
        style={{
          maxWidth: '175px',
          maxHeight: '200px',
          width: inline ? '20%' : '100%',
          height: inline ? '25%' : '100%',
        }}
      />

      <Typography
        level={inline ? Level.TITLE_MD : Level.H3}
        sx={{ fontWeight: 500, maxWidth: '50%', textAlign: 'center' }}
      >
        {t('messagePartBomNoParts')}
      </Typography>
    </Stack>
  );
};
